<script setup lang="ts">
import {
	AccordionRoot,
	useForwardPropsEmits,
	type AccordionRootEmits,
	type AccordionRootProps,
} from "reka-ui";

const props = defineProps<AccordionRootProps>();
const emit = defineEmits<AccordionRootEmits>();

const forwarded = useForwardPropsEmits(props, emit);
</script>

<template>
	<AccordionRoot v-bind="forwarded">
		<slot />
	</AccordionRoot>
</template>
